import { TagMatchingType } from "entities/modules/types";
import Select, { SelectOption } from "shared/components/Form/Select";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_DARK_RED } from "shared/theme/colors";
import { DeleteIcon } from "shared/theme/icons/DeleteIcon";
import { TagOption } from "widgets/ModuleTagsWidget/type";
import TagsAutocomplete from "./components/TagsAutocomplete";
import TagsSelectSkeleton from "./skeleton";
import { StyledIconButton } from "./styled";

type TagTypeOption = {
  value: string;
  label: string;
};

type Props<TagType> = {
  selectedTagType: TagType | null;
  selectedPrimaryTagId: string | null;
  tagTypeOptions: TagTypeOption[];
  primaryTagOptions: SelectOption[];
  selectedTags: TagOption[];
  secondaryTagOptions: TagOption[];
  onTagTypeChange: (tagType: TagType) => void;
  onChangePrimaryTag: (primaryTagId: string) => void;
  onDeleteTagBlock: () => void;
  onSecondaryTagsChange: (tags: TagOption[]) => void;
  deletable?: boolean;
  isLoadingTags?: boolean;
  isVisibleMatchingType?: boolean;
  matchingType?: TagMatchingType;
  onMatchingTypeChange?: (matchingType: TagMatchingType) => void;
};

const GameTagGroup = <TagType extends string>(props: Props<TagType>) => {
  const {
    selectedTagType,
    selectedTags,
    secondaryTagOptions,
    tagTypeOptions,
    onTagTypeChange,
    primaryTagOptions,
    selectedPrimaryTagId,
    onChangePrimaryTag,
    onDeleteTagBlock,
    onSecondaryTagsChange,
    isLoadingTags,
  } = props;

  return (
    <div>
      <Select
        options={tagTypeOptions}
        handleChange={(value) => onTagTypeChange(value as TagType)}
        label="Tag Type"
        placeholder="Select a type"
        value={selectedTagType || ""}
      />

      <FlexCenter gap={1} mb="1rem" mt="0.5rem">
        <Select
          value={selectedPrimaryTagId || ""}
          options={primaryTagOptions}
          handleChange={(value) => {
            onChangePrimaryTag(value as string);

            if (selectedPrimaryTagId !== value) {
              onSecondaryTagsChange([]);
            }
          }}
          label="Primary"
          placeholder="Select a tag"
          disabled={!selectedTagType}
        />
      </FlexCenter>
      <div>
        <FlexCenter width="100%" mt="0.5rem">
          {isLoadingTags && <TagsSelectSkeleton />}
          {!isLoadingTags && (
            <TagsAutocomplete
              value={selectedTags}
              options={secondaryTagOptions}
              onChange={onSecondaryTagsChange}
              placeholder="Add a tag..."
              loading={isLoadingTags ?? false}
              label="Secondary"
              disabled={!selectedTagType || !selectedPrimaryTagId}
            />
          )}
        </FlexCenter>
      </div>
      <StyledIconButton onClick={onDeleteTagBlock}>
        <DeleteIcon size={22} color={COLOR_DARK_RED} />
        Remove
      </StyledIconButton>
    </div>
  );
};

export default GameTagGroup;
